import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Tabs, Tab } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { EventForm } from './EventForm';
import Iconify from '../../../../../components/Iconify';
import { useSelector } from 'react-redux';
import { PLEventForm } from './PLEventForm';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allSeasons, allResorts, allAgeRanges, allCamps } = props;
  const { module } = useSelector(state => state.app);
  const [currentTab, setCurrentTab] = React.useState(0);

  return (
    <Scrollbar>
      { currentTab === 0
        ? <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
          <Stack flex="1 1 70%">
            <Card>
              <CardHeader title={data ? 'Edytuj imprezę' : 'Dodaj imprezę'} sx={{ mt: -1, mb: -2 }} />
              <CardContent>
                { module == 'obozy'
                  ? <EventForm
                    data={data}
                    submitCallback={submitCallback}
                    handleClose={handleClose}
                    allSeasons={allSeasons}
                    allResorts={allResorts}
                    allAgeRanges={allAgeRanges}
                    allCamps={allCamps} />
                  : <PLEventForm
                    data={data}
                    submitCallback={submitCallback}
                    handleClose={handleClose}
                    allSeasons={allSeasons}
                    allResorts={allResorts}
                    allAgeRanges={allAgeRanges}
                    allCamps={allCamps} />}
              </CardContent>
            </Card>
          </Stack>
        </Box>
        : <Box>asd</Box>}
    </Scrollbar>
  );
};
